import script from "./TabelaInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabelaInput.vue?vue&type=script&setup=true&lang=ts"

import "./TabelaInput.vue?vue&type=style&index=0&id=bcc01538&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bcc01538"]])

export default __exports__